import { Paper, Box, Typography, Grid, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { useTranslate } from "ra-core";
import SfBreadcrumb from "../../../components/SfBreadcrumbs";
import BigTab from "../../../components/BigTab";
import MemberInfoPanel from "../../../components/MemberInfoPanel";
import { isLiteVersion } from "../../../utils/settings";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  breadcrumb: {
    marginTop: 30,
  },
  topics: {
    marginTop: 83,
    fontSize: 20,
    fontWeight: "bolder",
  },
  mLeft: {
    marginLeft: 101,
  },
  box: {
    marginTop: 38,
    width: 462,
    height: 130,
  },
  itemInBoxContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
  },
  icon: {
    width: 56,
    height: 64,
    marginLeft: 31,
  },
  leftPanel: {
    backgroundColor: theme.default.normal.backgroundColor,
    width: "100%",
    overflowY: "hidden",
    display: "flex",
    flexDirection: "column",
    flex: "1 0 auto",
  },
  bigIconwithTextContainer_text: { color: theme.white, marginLeft: 33 },
  rightPanel: {
    backgroundColor: "white",

    overflowY: "scroll",
  },
}));

const PaymentMemberMainMenu = () => {
  const classes = useStyles();
  const history = useHistory();
  const member = history.location.state.member;
  const translate = useTranslate();

  return (
    <Paper className={classes.allContainer}>
      <Grid container style={{ flexGrow: 1 }}>
        <Grid item xs={8} className={classes.leftPanel}>
          <SfBreadcrumb path="/Payment/Member" className={classes.breadcrumb} />
          <Typography className={[classes.topics, classes.mLeft]}>
            {translate("ra.text.payment.member.selectMemberType")}
          </Typography>
          <BigTab
            selected
            onClick={() => {
              history.replace({
                pathname: isLiteVersion()
                  ? "/payment/lite"
                  : "/payment/addproduct",
                state: { member: member },
              });
            }}
            className={[classes.box, classes.mLeft]}
            disabled
          >
            <Box className={classes.itemInBoxContainer}>
              <MoneyOffIcon className={classes.icon} />
              <Typography
                variant="h4"
                className={classes.bigIconwithTextContainer_text}
              >
                Outstanding Balance
              </Typography>
            </Box>
          </BigTab>
          <BigTab
            selected
            onClick={() => {
              history.replace({
                pathname: isLiteVersion()
                  ? "/payment/lite"
                  : "/payment/addproduct",
                state: { member: member },
              });
            }}
            label="MEMBER"
            className={[classes.mLeft, classes.box]}
          >
            <Box className={classes.itemInBoxContainer}>
              <ShoppingCartOutlinedIcon className={classes.icon} />
              <Typography
                variant="h4"
                align="left"
                className={classes.bigIconwithTextContainer_text}
              >
                Add Products
              </Typography>
            </Box>
          </BigTab>
          <BigTab
            selected
            onClick={() => {
              history.replace({
                pathname: isLiteVersion()
                  ? "/payment/lite"
                  : "/payment/addproduct",
                state: { member: member },
              });
            }}
            label="MEMBER"
            className={[classes.box, classes.mLeft]}
            disabled
          >
            <Box className={classes.itemInBoxContainer}>
              <AccountBalanceWalletIcon className={classes.icon} />
              <Typography
                variant="h4"
                className={classes.bigIconwithTextContainer_text}
              >
                Add B-Wallet
              </Typography>
            </Box>
          </BigTab>
        </Grid>
        <Grid item xs={4} className={classes.rightPanel}>
          <MemberInfoPanel id={member.id} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default PaymentMemberMainMenu;
